import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.97 1.816a5.23 5.23 0 0 1 1.28 3.434v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.28 9.77 9.77 0 0 0-6.963-6.964"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5zm3.595 9.72a.75.75 0 0 1 1.06 0L12 12.94l1.72-1.72a.75.75 0 1 1 1.06 1.06L13.06 14l1.72 1.72a.75.75 0 1 1-1.06 1.06L12 15.06l-1.72 1.72a.75.75 0 1 1-1.06-1.06L10.94 14l-1.72-1.72a.75.75 0 0 1 0-1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }